var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRealEstateActionHouse = function SvgRealEstateActionHouse(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3438 27.1562H7.21875C6.67174 27.1562 6.14714 26.939 5.76034 26.5522C5.37355 26.1654 5.15625 25.6408 5.15625 25.0938V14.7812",
    stroke: "url(#paint0_linear_666_43)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03125 12.7188L13.1051 2.50252C13.4775 2.18735 13.9496 2.0144 14.4375 2.0144C14.9254 2.0144 15.3975 2.18735 15.7699 2.50252L25.7785 10.9711",
    stroke: "url(#paint1_linear_666_43)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6562 2.40625H25.7812V6.53125",
    stroke: "url(#paint2_linear_666_43)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7814 18.9062H22.9861C22.5576 18.9065 22.1427 19.0559 21.8124 19.3287C21.482 19.6015 21.2569 19.9807 21.1756 20.4013C21.0943 20.822 21.1619 21.2578 21.3668 21.634C21.5717 22.0102 21.9011 22.3035 22.2986 22.4634L25.1366 23.5991C25.534 23.759 25.8634 24.0523 26.0683 24.4285C26.2732 24.8047 26.3408 25.2405 26.2595 25.6612C26.1782 26.0818 25.9531 26.461 25.6227 26.7338C25.2924 27.0066 24.8775 27.156 24.4491 27.1562H21.6564",
    stroke: "url(#paint3_linear_666_43)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7188 18.9062V17.875",
    stroke: "url(#paint4_linear_666_43)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7188 28.1875V27.1562",
    stroke: "url(#paint5_linear_666_43)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4688 23.0312C15.4688 25.2193 16.3379 27.3177 17.8851 28.8649C19.4323 30.4121 21.5307 31.2812 23.7188 31.2812C25.9068 31.2812 28.0052 30.4121 29.5524 28.8649C31.0996 27.3177 31.9688 25.2193 31.9688 23.0312C31.9688 20.8432 31.0996 18.7448 29.5524 17.1976C28.0052 15.6504 25.9068 14.7812 23.7188 14.7812C21.5307 14.7812 19.4323 15.6504 17.8851 17.1976C16.3379 18.7448 15.4688 20.8432 15.4688 23.0312Z",
    stroke: "url(#paint6_linear_666_43)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_666_43",
    x1: 11.3438,
    y1: 21.067,
    x2: 5.15625,
    y2: 21.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_666_43",
    x1: 25.7785,
    y1: 7.45154,
    x2: 1.03125,
    y2: 7.45154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_666_43",
    x1: 25.7813,
    y1: 4.50149,
    x2: 21.6563,
    y2: 4.50149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_666_43",
    x1: 26.293,
    y1: 23.0967,
    x2: 21.1421,
    y2: 23.0967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_666_43",
    x1: 24.7188,
    y1: 18.3988,
    x2: 23.7188,
    y2: 18.3988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_666_43",
    x1: 24.7188,
    y1: 27.6801,
    x2: 23.7188,
    y2: 27.6801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_666_43",
    x1: 31.9688,
    y1: 23.1622,
    x2: 15.4688,
    y2: 23.1622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DD3C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5F1"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRealEstateActionHouse);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";